import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getPincdoeDetails } from "../../services/authenticationService";
import ErrorModal from "../common/ErrorModal";
import CInput from "../utils/CInput";
import CSelectBox from "../utils/CSelectBox";
import { setAppLoader } from "../../actions/setAppLoader";

export default function CurrentAddressV1({ userAddressData, onPinChange }) {
  
  const navigate = useNavigate();
  const [pinCode, setPinCode] = React.useState();
  const [pinCodeVerified, setpinCodeVerified] = React.useState(false);
  const [city, setCity] = React.useState(userAddressData?.city || "");
  const [currentUserAddressData, setCurrentUserAddressData] = React.useState();

  const [cityList, setCityList] = React.useState([]);
  const [userState, setUserState] = React.useState(
    userAddressData?.state || ""
  );
  const [userStreet, setUserStreet] = React.useState(
    userAddressData?.street || ""
  );
  const [userAddress, setUserAddress] = React.useState(
    userAddressData?.address || ""
  );
  const [locationError, setLocationError] = React.useState(false);

  const [error, setError] = React.useState(false);

  const dispatch = useDispatch();

  React.useEffect(() => {
    setCurrentUserAddressData({
      line_1: userAddress,
      line_2: "",
      line_3: "",
      street: userStreet,
      city: city,
      state: userState,
      pincode: pinCode,
    });
    onPinChange(currentUserAddressData, pinCodeVerified);
  }, [pinCodeVerified, onPinChange, city, userState, userStreet, userAddress, currentUserAddressData, pinCode]);

  React.useEffect(() => {
    if (userAddressData) {
      setUserAddress(
        `${userAddressData?.line_1 ?? ""} ${userAddressData?.line_2 ?? ""}`
      );
      setUserStreet(userAddressData?.street || "");
      setPinCode(userAddressData?.pincode || "");
      setUserStreet(userAddressData?.street ?? "");
      const cityList = [
        {
          name: userAddressData?.city,
          value: userAddressData?.city.toLowerCase(),
        },
      ];
      setCityList(cityList);
      setCity(userAddressData?.city.toLowerCase());
      setUserState(userAddressData?.state || "");
      setCurrentUserAddressData({
        line_1: `${userAddressData?.line_1 ?? ""} ${
          userAddressData?.line_2 ?? ""
        }`,
        line_2: "",
        line_3: "",
        street: userAddressData?.street || "",
        city: userAddressData?.city.toLowerCase(),
        state: userAddressData?.state || "",
        pincode: userAddressData?.pincode || "",
      });
      validatePinCode(userAddressData?.pincode, userAddressData?.city.toLowerCase());
    }
  }, [userAddressData]);

  async function onPinVerifyClick(e) {
    setPinCode(e);
    if (!e || e.length < 6) {
      setpinCodeVerified(false);
      return;
    }
    dispatch(setAppLoader(true));
    validatePinCode(e, "");

    dispatch(setAppLoader(false));
  }

  function validatePinCode(e, selectedCity) {
    getPincdoeDetails(e).then((data) => {
      console.log("pincode details", data);
      if (data.response != null && data.response.length) {
        console.log("pincode details 1", data);
        const cityList = [];
        const districtSet = new Set();

        data?.response?.forEach((element) => {
          if (!districtSet.has(element.district.toLowerCase())) {
            districtSet.add(element.district.toLowerCase());
            cityList.push({
              name: element.district,
              value: element.district.toLowerCase(),
              state: element.state,
            });
          }
        });
        if(cityList.includes(selectedCity)){
          setCity(selectedCity);
        } else {
          setCity("");
        }
        setCityList(cityList);
        setUserState(cityList?.length ? cityList[0].state : "");
        setpinCodeVerified(true);
        onPinChange(e, true);
      } else if (data.success === false) {
        console.log("pincode details 2", data);
        setpinCodeVerified(false);
        onPinChange(e, false);
      } else {
        console.log("pincode details 3", data);
        setpinCodeVerified(false);
        if(selectedCity === "") {
          setLocationError(true);
        }
        setCity("");
        setCityList([]);
        setUserState("");
        onPinChange(e, false);
      }
    });
  }

  return (
    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
      <Grid item xs={12} sm={12}>
        <Box className="form" sx={{ mt: 1 }}>
          <CInput
            type="text"
            placeholder="Street address"
            isError={error ? true : false}
            name="address"
            value={userAddress}
            onChange={(e) => {
              setUserAddress(e);
            }}
            label="Address*"
            subtitle="Kindly validate if below record matches your current residential address. (Edit if needed)"
          />
        </Box>
      </Grid>
      <Grid item xs={12} sm={12}>
        <Box className="form" sx={{ mt: 1 }}>
          <CInput
            type="text"
            placeholder="Landmark"
            isError={error ? true : false}
            name="landmark"
            value={userStreet}
            onChange={(e) => {
              setUserStreet(e);
            }}
            label=""
          />
        </Box>
      </Grid>
      <Grid item xs={4} sm={4}>
        <Box className="form" sx={{ mt: 1 }}>
          <CInput
            type="number"
            maxLength={6}
            name="pin"
            label=""
            placeholder="Pincode"
            value={pinCode}
            onChange={onPinVerifyClick}
          />
        </Box>
      </Grid>
      <Grid item xs={4} sm={4}>
        <Box className="form" sx={{ mt: 1 }}>
          <CSelectBox
            onChange={(e) => {
              setCity(e);
            }}
            optionList={cityList}
            defaultValue={city}
            name="city"
            label=""
            disable={!pinCodeVerified}
          />
        </Box>
      </Grid>
      <Grid item xs={4} sm={4}>
        <Box className="form" sx={{ mt: 1 }}>
          <CInput
            type="text"
            placeholder="State"
            isError={error ? true : false}
            name="state"
            value={userState}
            onChange={(e) => {
              setUserState(e);
            }}
            label=""
            disabled={true}
          />
        </Box>
      </Grid>
      {pinCode && !pinCodeVerified && (
        <Grid item>
          <Typography variant="body2" color="textColorR" sx={{ mt: 1 }}>
            Pincode is not serviceable. Please enter a valid pincode.
          </Typography>
        </Grid>
      )}

      {pinCode && pinCodeVerified && (!city || !userState) && (
        <Grid item>
          <Typography variant="body2" color="textColorR" sx={{ mt: 1 }}>
            Please select correct city & state for your address.
          </Typography>
        </Grid>
      )}

      {locationError && (
        <ErrorModal open={locationError} setOpen={setLocationError} />
      )}
    </Grid>
  );
}
